module.exports = __webpack_public_path__ + "static/finovate-topleass-atm-2014-e2b314365c464ab7151844bb293b856a.webp";